// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kHpla","container":"Footer_container__MJyCl"};